import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubGeographicalRegion, SubGeographicalRegionDataIn } from '../models/sub-geographical-regions.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root'
})
export class SubGeographicalRegionService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + "cim/SubGeographicalRegion/";
  }

  save(district: SubGeographicalRegionDataIn): Observable<any> {
    return this.http.post(`${this.pathApi}create`, district, { headers: this.headers, observe: 'response' });
  }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAllForMappings(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForMappings`, {
      headers: this.headers,
      observe: 'response',
    });
  }
  getByGeographicalRegionIds(geographicalRegions: (number|null)[]| undefined ): Observable<any> {
    return this.http.post(`${this.pathApi}getByGeographicalRegionIds`, geographicalRegions, { observe: 'response' });
  }
}
